import { capitalize } from '@carboncopyco/utils';

export const beautifyTableLabel = (text: string) => {
  if (text.includes('_') || text.includes('-')) {
    return text;
  }

  return capitalize(
    text
      .split(/(?=[A-Z])/)
      .join(' ')
      .toLowerCase()
  );
};
